module.exports = __webpack_public_path__ + "img/7511dc3.png";